import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ToggleLoadViewDialogCommand {
  open: boolean;
}

export const toggleLoadViewDialog: GraphCommandFactory<
  ToggleLoadViewDialogCommand | undefined
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.loadViewDialog.open = command?.open ?? !draft.loadViewDialog.open;
  });
};
